import { initVehicleSelectWidget, setCookie, removeCookie } from "../utils/fn";

export const m1FindVehicleEu = async () => {
  const widgets = document.querySelectorAll('.m1-find-vehicle-eu-wrapper');

  widgets.forEach(widget => {
    const parentVehicleWidget = widget.closest('.m1-find-vehicle-eu');
    const form = widget.querySelector('form');
    if(!parentVehicleWidget.classList.contains('initialized')) {
      initVehicleSelectWidget(widget, i18n, parentVehicleWidget.classList.contains('initialized'));
    };
    

    form.addEventListener('submit', function(event) {
      event.preventDefault();

      const formData = new FormData(form);
      const data = Array.from(formData.entries());

      gtmDataLayer.push({
        event: 'findVehicleSubmit',
      });

      if (!data.length && form.dataset.cseType === 'drivek') {
        window.location.href = form.dataset.drivekUrl;
        return;
      }

      const emptyData = [];

      data.forEach(([name, value]) => {
        if (typeof value === 'string' && value.trim() !== '') {
          emptyData.push(value);
        }
      });

      const href = '/' + emptyData.join('/') + '/';
      window.location.href = href;
    });
    parentVehicleWidget.classList.add('initialized');
  });
};
